import styled from 'styled-components';

const RadioStyled = styled.div`
  position: relative;

  > label {
    cursor: pointer;
    display: flex;
    justify-content: start;
    align-items: center;
    width: 100%;
    min-height: 50px;

    > input[type='radio'] {
      appearance: none;
      background-color: #fff;
      margin: 0;
      min-width: 22px;
      min-height: 22px;
      border: 2px solid #999;
      border-radius: 50%;
      margin-right: 30px;
      transform: translateY(-0.075em);
      cursor: pointer;
      position: relative;

      &:checked {
        border: 11px solid ${({ theme }) => theme.buttonPrimaryColor};

        &:after {
          content: '';
          position: absolute;
          top: calc(50% - 8px);
          left: calc(50% - 8px);
          right: 0;
          bottom: 0;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: transparent;
          border: 3px solid #fff;
          box-sizing: content-box;
        }
      }
    }
  }

  + div {
    border-top: 1px solid #e8e8e8;
  }
`;

export default RadioStyled;
export { RadioStyled };
